import { useEffect, useRef } from "react";

export const useInactivityReset = (
  resetCallback: () => void,
  resetTime: number
) => {
  const isResetting = useRef<boolean>(false);

  useEffect(() => {
    let resetTimeout: NodeJS.Timeout | null;

    const resetComponent = () => {
      isResetting.current = false;
      resetCallback();
    };

    const resetTimer = () => {
      isResetting.current = true;
      resetTimeout && clearTimeout(resetTimeout);
      resetTimeout = setTimeout(resetComponent, resetTime);
    };

    const handleClick = () => {
      resetTimer();
    };

    const handleKeyDown = () => {
      resetTimer();
    };

    const handleTouchStart = () => {
      resetTimer();
    };

    document.addEventListener("click", handleClick);
    document.addEventListener("keydown", handleKeyDown);
    document.addEventListener("touchstart", handleTouchStart);

    isResetting.current && resetTimer();

    return () => {
      document.removeEventListener("click", handleClick);
      document.removeEventListener("keydown", handleKeyDown);
      document.removeEventListener("touchstart", handleTouchStart);
      resetTimeout && clearTimeout(resetTimeout);
    };
  });
};
